module.exports = __webpack_public_path__ + "img/core9.f1153891.jpg";